import loadMonetateModule from './modules/Monetate.module';
import loadWishListModule from './modules/WishList.module';
import loadCompareModule from './modules/Compare.module';
import loadCookieConsentModule from './modules/CookieConsent.module';
import loadProductModule from './modules/Product.module';
const loadProductGroupPdpComparisonMonetateRootModule = () => {
    return {
        hasRouter: false,
        modules: [
            loadMonetateModule(),
            loadCookieConsentModule(),
            loadCompareModule(),
            loadWishListModule(),
            loadProductModule(),
        ],
    };
};
export default loadProductGroupPdpComparisonMonetateRootModule;
